<div class="modal fade show" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{"meetings." + (isUpdate ? 'Edit' : 'Add') + " Slide" | translate}}</h4>

        <button type="button" class="close" aria-label="Close" (click)="closePop()">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">

        <form [formGroup]="formGroup" class="slide-form">
          <div class="form-group">
              <mat-form-field>
                  <mat-label>{{ 'meetings.Tissue type' | translate }}</mat-label>
                  <mat-select class="optional-field" (keyup)="activeGroups()" formControlName="tissueType" [class.loading-field]="dataLoading">
                    <mat-select-trigger>
                      {{selectedSubspeciality?.name}} / {{selectedTissueType?.name}}
                    </mat-select-trigger>
                    <mat-option [value]="" (click)="clearSpaciality()"></mat-option>
                    <mat-optgroup class="slide-form-mat-optgroup"
                      *ngFor="let group of slideLookUps?.tissueWithSubspecialityLookupDTOs"
                      [class.active]="group.active"
                      (click)="group.active = !group.active"
                      [label]="group.name">
                      <span class="btn">
                        <svg *ngIf="group.active" width="15" height="9" viewBox="0 0 15 9">
                          <path id="collapse-icon" d="M806.028,397.634l-5.968,5.949-1.532-1.527,7.5-7.473,7.5,7.473L812,403.582Z" transform="translate(-798.528 -394.583)" fill="#999"/>
                        </svg>
                        <svg *ngIf="!group.active" width="9" height="14" viewBox="0 0 9 14">
                          <path id="expand-icon" d="M7,5.949,1.43,0,0,1.527,7,9l7-7.473L12.57,0Z" transform="translate(0 14) rotate(-90)" fill="#999"/>
                        </svg>
                      </span>
                      <mat-option *ngFor="let child of group.childs"
                        (keyup.enter)="activateParent(group, child)"
                        (click)="activateParent(group, child)"
                        [hidden]="!group.active" [value]="child.id">
                        {{child.name}}
                      </mat-option>
                    </mat-optgroup>
                  </mat-select>
                  <span class="optional">({{ 'entityCom.Optional' | translate }})</span>
              </mat-form-field>
          </div>
          <div class="form-group">
              <mat-form-field>
                  <mat-label>{{ 'meetings.Specimen Source' | translate }}</mat-label>
                  <mat-select class="optional-field" formControlName="specimenSource" [class.loading-field]="dataLoading">
                      <mat-option [value]=""></mat-option>
                      <mat-option *ngFor="let item of slideLookUps?.specimenSourceLookupDTO"
                        [value]="item.specimenSourceId">{{item.specimenSourceName}}</mat-option>
                  </mat-select>
                  <span class="optional">({{ 'entityCom.Optional' | translate }})</span>
              </mat-form-field>
          </div>
          <div class="form-group">
              <mat-form-field>
                  <mat-label>{{ 'meetings.Stain type' | translate }}</mat-label>
                  <mat-select class="optional-field" formControlName="stainType" [class.loading-field]="dataLoading">
                      <mat-option [value]=""></mat-option>
                      <mat-option *ngFor="let item of slideLookUps?.stainTypes"
                        [value]="item.id">{{item.name}}</mat-option>
                  </mat-select>
                  <span class="optional">({{ 'entityCom.Optional' | translate }})</span>
              </mat-form-field>
          </div>
          <!-- <div class="form-group">
              <mat-form-field>
                  <mat-label>{{ 'meetings.Related agenda item' | translate }}</mat-label>
                  <mat-select class="optional-field" formControlName="meetingAgendaItemId">
                      <mat-option [value]=""></mat-option>
                      <mat-option *ngFor="let item of agendItems"
                        [value]="item.agendaItemEntityId">{{item.title}}</mat-option>
                  </mat-select>
                  <span class="optional">({{ 'entityCom.Optional' | translate }})</span>
              </mat-form-field>
          </div> -->
          <ng-container *ngIf="!isUpdate">
            <div class="form-group mt-4">
              <div class="type-selector">
                <label>{{ 'meetings.Select how you want to add the slide' | translate }}</label>
                <mat-radio-group class="row" formControlName="CommunicationMethodLookup" (change)="typeChange()">
                  <mat-radio-button class="col" [value]="meeting.pathologyCommunictions.network.lookupCode"
                    *ngIf="meeting.pathologyCommunictions?.network">
                    {{ 'entityCom.Network' | translate }}
                  </mat-radio-button>
                  <mat-radio-button class="col" [value]="meeting.pathologyCommunictions.ftp.lookupCode"
                    *ngIf="meeting.pathologyCommunictions?.ftp">
                    {{ 'entityCom.FTP' | translate }}
                  </mat-radio-button>
                  <mat-radio-button class="col" [value]="meeting.pathologyCommunictions.local.lookupCode"
                    *ngIf="meeting.pathologyCommunictions?.local">
                    {{ 'entityCom.Local' | translate }}
                  </mat-radio-button>
                  <mat-radio-button class="col" [value]="meeting.pathologyCommunictions.ceph.lookupCode"
                    *ngIf="meeting.pathologyCommunictions?.ceph">
                    {{ 'entityCom.CEPH' | translate }}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div class="form-group" [hidden]="formGroup.controls['CommunicationMethodLookup'].value == 3">
              <mat-form-field>
                  <mat-label>{{ 'meetings.Select Slide' | translate }}</mat-label>
                  <mat-select formControlName="SelectedSlide"
                    [class.loading-field]="slidesLoading"
                    [required]="formGroup.controls['CommunicationMethodLookup'].value != 3">
                      <mat-option [value]=""></mat-option>
                      <mat-option *ngFor="let slide of slides" [value]="slide">{{slide}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="hasError('SelectedSlide', 'required')">{{ 'messages.required' | translate }}</mat-error>
              </mat-form-field>
          </div>
          <div class="form-element" *ngIf="formGroup.controls['CommunicationMethodLookup'].value == 3">
            <div class="form-group">
              <label class="mb-2">{{ 'meetings.Upload WSI slide file' | translate }}</label>
                <app-file-manager
                    [files]='files'
                    [managerIndex]='456'
                    [maxFileSize]='100'
                    [maxFiles]="1"
                    [isSubmited]="isSubmited"
                    [allowedExt]="['svs', 'TIF', 'NDPI', 'SCN', 'MRXS', 'SVSLIDE', 'BIF']"
                    [showFilesInfo]="true"
                    [isRequired]="formGroup.controls['CommunicationMethodLookup'].value == 3"
                    (selectedFiles)="files = $event"></app-file-manager>
            </div>
          </div>
          </ng-container>

          <div class="modal-btns mt-5">
            <button type="reset" class="close closebtn" (click)="closePop()">
              {{ 'swalMsg.cancel' | translate }}
            </button>
            <button mat-raised-button class="btn customBtn px-4" (click)="save()" [disabled]="loading"
              [ngClass]="{ 'loading': loading}">
              {{"meetings." + (isUpdate ? 'Edit' : 'Add') + " Slide" | translate}}
            </button>
          </div>
        </form>

      </div>

    </div>
  </div>
</div>
